module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit_wrap"
  }, [_c('div', {
    staticClass: "pl10 pr10 mt20",
    staticStyle: {
      "word-break": "break-all"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showReason),
      expression: "showReason"
    }],
    staticClass: "mt20 mb20"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_vm._v("驳回原因：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_c('span', {
    staticClass: "main_word"
  }, [_vm._v(_vm._s(_vm.scheduleObj.schedule))])])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 2
    }
  }, [(_vm.scheduleObj.content) ? _c('div', {
    staticClass: "grid-content"
  }, [_vm._v("(" + _vm._s(_vm.scheduleObj.content) + ")")]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "ml20"
  }, [_vm._v("扩充分类基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "mt20 ml20"
  }, [_c('el-form', {
    staticClass: "demo-ruleForm",
    attrs: {
      "label-width": "180px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "扩充分类申请编号："
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.infoData.agreementCode) + "\n                ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品牌申请编号："
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.infoData.pcode) + "\n                ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "关联供应商合同编号："
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.infoData.contractCode) + "\n                ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "供应商编号："
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.infoData.supplierCode) + "\n                ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "供应商名称："
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.infoData.supplierName) + "\n                ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合作方式："
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.infoData.cooperationTypeDesc) + "\n                ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结算主体："
    }
  }, [(_vm.infoData.settlementBodyId == 1) ? _c('span', [_vm._v("北京果敢时代科技有限公司")]) : _vm._e(), _vm._v(" "), (_vm.infoData.settlementBodyId == 2) ? _c('span', [_vm._v("MAMA HONG KONG")]) : _vm._e(), _vm._v(" "), (_vm.infoData.settlementBodyId == 3) ? _c('span', [_vm._v("天津果敢时代国际贸易有限公司")]) : _vm._e(), _vm._v(" "), (_vm.infoData.settlementBodyId == 4) ? _c('span', [_vm._v("正合奇胜（天津）企业咨询管理有限公司")]) : _vm._e(), _vm._v(" "), (_vm.infoData.settlementBodyId == 5) ? _c('span', [_vm._v("老师线下打款")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合同有效期："
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("time")(_vm.infoData.startTime)) + "至" + _vm._s(_vm._f("time")(_vm.infoData.endTime)) + "\n                ")])], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "ml20"
  }, [_vm._v("品牌品类信息")]), _vm._v(" "), _c('div', {
    staticClass: "mt20 mb20 clearfix"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.infoData.agreementCategories,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "74",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "品牌中文名称",
      "min-width": "80",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          attrs: {
            "href": '#/supplierBrandDetail?agreementBrandId=' + scope.row.attributeId,
            "target": "_blank"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          }
        }, [_vm._v(_vm._s(scope.row.brandName))])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "主营品类",
      "width": "200",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.category.grandName) + "--")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.category.parentName) + "--")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.category.childrenName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否提供发票",
      "width": "140",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.provideInvoice == 0) ? _c('span', [_vm._v("否")]) : _vm._e(), _vm._v(" "), (scope.row.provideInvoice == 1) ? _c('span', [_vm._v("是")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "发票类型",
      "align": "center",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.provideInvoice == 0) ? _c('span', [_vm._v("无")]) : _vm._e(), _vm._v(" "), (scope.row.provideInvoice == 1 && _vm.registeredCountry == 1 && scope.row.invoiceType == 1) ? _c('span', [_vm._v("增值税普通发票")]) : _vm._e(), _vm._v(" "), (scope.row.provideInvoice == 1 && _vm.taxpayerType == 1 && _vm.registeredCountry == 1 && scope.row.invoiceType == 2) ? _c('span', [_vm._v("增值税专用发票")]) : _vm._e(), _vm._v(" "), (scope.row.provideInvoice == 1 && _vm.taxpayerType == 2 && _vm.registeredCountry == 1 && scope.row.invoiceType == 2) ? _c('span', [_vm._v("增值税专用发票（需去税务局代开）")]) : _vm._e(), _vm._v(" "), (scope.row.provideInvoice == 1 && _vm.registeredCountry != 1 && scope.row.invoiceType == 3) ? _c('span', [_vm._v("形式发票")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "税率",
      "align": "center",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.rates.length == 0) ? _c('span', [_vm._v("无")]) : _vm._e(), _vm._v(" "), _vm._l((scope.row.rates), function(rateValue) {
          return (scope.row.rates.length > 0) ? _c('span', [_vm._v("\n                                " + _vm._s(rateValue) + "%\n                                ")]) : _vm._e()
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "label": "品类经营特许资质电子版",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.franchiseQualification == 1) ? _c('img', {
          staticClass: "pic_skan",
          attrs: {
            "src": scope.row.franchiseQualificationFile
          },
          on: {
            "click": function($event) {
              _vm.previewPic($event)
            }
          }
        }) : _vm._e(), _vm._v(" "), (!scope.row.franchiseQualification == 1) ? _c('span', [_vm._v("不需要")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "statusDesc",
      "label": "合作状态",
      "min-width": "220",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          attrs: {
            "target": "_blank",
            "href": '#/supplierBrandDetail' + '?agreementBrandId=' + scope.row.attributeId
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          }
        }, [_vm._v("查看")])], 1), _vm._v(" "), (_vm.editAuth && scope.row.status == 1) ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.endAgreementCategory(scope.row.id, scope.row.type)
            }
          }
        }, [_vm._v("\n                            终止合作\n                        ")]) : _vm._e()]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mb20",
    attrs: {
      "align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.reback()
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f824512"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/supplierInfo/brandSupplement.vue
// module id = 485
// module chunks = 0